import { ButtonRoot } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { CLIPBOARD_CARD_STATUS_LABELS } from '@/defs/clipboard'
import { type RecType } from '@/defs/rec'
import { useClipboardButton } from '@/hooks/useClipboardButton'
import { cn } from '@/utils/commonUtil'
import { getRecCardRefs } from '@/utils/recUtil'

import styles from './GalleryViewTableClipboardButton.module.scss'

type Props = {
  rec: RecType
}

export const GalleryViewTableClipboardButton = ({ rec }: Props) => {
  const cardRefs = getRecCardRefs(rec)
  const { isAllInClipboard, onToggleAllClick } = useClipboardButton({ cardRefs })

  const status = isAllInClipboard ? 'saved' : 'unsaved'
  const { actionLabel, icon } = CLIPBOARD_CARD_STATUS_LABELS[status]

  return (
    <ButtonRoot
      aria-label={actionLabel}
      className={cn(styles.container, { isAllInClipboard, styles })}
      onClick={onToggleAllClick}
      title={actionLabel}
    >
      <Icon name={icon} />
    </ButtonRoot>
  )
}
